// extracted by mini-css-extract-plugin
module.exports = {"recipe":"Recipe_recipe__1H7TC","image":"Recipe_image__2Av3E"};